import { oc } from '@orpc/contract';
import { vehicleAttributeOptionsSchema } from '../schemas/vehicles.schemas.js';
export const getVehicleAttributeOptionsContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/attribute-options',
    tags: ['Vehicles'],
    summary: 'Distinct manufacturers, segments and powertrains for the vehicle list filters',
})
    .output(vehicleAttributeOptionsSchema);
//# sourceMappingURL=get-vehicle-attribute-options.contract.js.map